<template>
  <div v-if="false"></div>
</template>

<script>
import { gmapApi } from "vue2-google-maps";
export default {
  name: "DirectionsRenderer",
  props: {
    origin: {
      type: Object,
      required: true,
    },
    destination: {
      type: Object,
      required: true,
    },
    travelMode: {
      type: String,
      default: "WALKING",
    },
    waypoints: {
      type: Array,
      default: () => [],
    },
    suppressMarkers: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      directionsRenderer: null,
      interval: null,
    };
  },
  watch: {
    origin: "init",
    destination: "init",
    waypoints: "init",
  },
  methods: {
    init() {
      if (!this.google?.maps) return;

      clearInterval(this.interval);

      const directionsService = new this.google.maps.DirectionsService();
      if (!this.directionsRenderer) {
        this.directionsRenderer = new this.google.maps.DirectionsRenderer({
          suppressMarkers: this.suppressMarkers,
        });
        this.directionsRenderer.setMap(this.$parent.$mapObject);
      }

      const request = {
        origin: this.origin,
        destination: this.destination,
        travelMode: this.google.maps.TravelMode[this.travelMode],
      };

      if (this.waypoints?.length) {
        request.waypoints = this.waypoints;
        request.optimizeWaypoints = true;
      }

      directionsService.route(request, (result, status) => {
        if (status === "OK") {
          this.directionsRenderer.setDirections(result);
        } else {
          console.error("Directions request failed due to ", status);
        }
      });
    },
  },
  mounted() {
    this.interval = setInterval(this.init, 1000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
    if (this.directionsRenderer) {
      this.directionsRenderer.setMap(null);
      this.directionsRenderer = null;
    }
  },
  computed: {
    google: gmapApi,
  },
};
</script>
